<div class="page-wrapper chiller-theme toggled">
  <main class="page-content">
    <div class="container">
      <!-- Header -->
      <div class="row">
        <div class="col-md-6"><h3>Foreign College Videos</h3></div>
        <div class="col-md-6 text-end">
          <button class="btn btn-primary" (click)="openAdd()">
            <i class="fa fa-plus"></i> Add Video
          </button>
        </div>
      </div>

      <!-- AG Grid -->
      <div class="ag-theme-alpine mt-4" style="width: 100%;">
        <ag-grid-angular
          class="ag-theme-alpine"
          [rowData]="videosList"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          domLayout="autoHeight"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>

      <!-- ✅ Preview Modal -->
      <div class="preview-backdrop" *ngIf="previewImage" (click)="closeImagePreview()">
        <div class="preview-container" (click)="$event.stopPropagation()">
          <img [src]="previewImage" class="preview-img">
        </div>
      </div>

      <!-- Add Video Modal -->
      <div class="backdrop" [ngStyle]="{ display: display }"></div>
      <div class="modal" [ngStyle]="{ display: display }">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              Add College Video
              <button type="button" class="close" (click)="onCloseHandled()"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <form [formGroup]="videoForm">

                <!-- Country -->
                <label>Country</label>
                <select class="form-control" formControlName="country" (change)="onCountryChange($event.target.value)">
                  <option value="">-- Select Country --</option>
                  <option *ngFor="let c of countries" [value]="c.id">{{ c.country }}</option>
                </select>

                <!-- Course -->
                <label class="mt-2">Course</label>
                <select class="form-control" formControlName="course" (change)="onCourseChange($event.target.value)">
                  <option value="">-- Select Course --</option>
                  <option *ngFor="let crs of courses" [value]="crs.id">{{ crs.course_name }}</option>
                </select>

                <!-- College -->
                <label class="mt-2">College</label>
                <select class="form-control" formControlName="college">
                  <option value="">-- Select College --</option>
                  <option *ngFor="let clg of colleges" [value]="clg.id">{{ clg.college_name }}</option>
                </select>

                <!-- Video URL -->
                <label class="mt-2">Video URL</label>
                <input type="text" class="form-control" formControlName="url">

                <!-- Upload Thumbnail Images -->
                <label class="mt-2">Upload Thumbnail Images</label>
                <input type="file" multiple class="form-control" (change)="onFilesSelected($event)">
                <div class="d-flex flex-wrap mt-2">
                  <img *ngFor="let img of selectedImages" [src]="img" width="80" height="80" class="rounded border m-1" />
                </div>

                <button class="btn btn-success mt-3" type="button" (click)="addVideo()">Add Video</button>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
</div>
